import React, { useEffect, useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { Elements } from '@stripe/react-stripe-js'
import CheckoutForm from "../CheckoutForm";

import { loadStripe } from '@stripe/stripe-js'

import { AuthUserContext } from '../Session'
import { withFirebase } from '../Firebase'
import { updateUserDataInDB } from '../SignIn'
import { PasswordForgetLink } from '../PasswordForget'
import { BlancheLogoRed, FacebookIcon, GoogleIcon, UlListIcon } from '../Icons'
import * as ROUTES from '../../constants/routes'

import { Trans, useTranslation } from 'react-i18next'
import { LanguageSwitcher } from '../Navigation'

import { taxRates, ErrorsObj } from '../common'

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY)

// set true, if you want to use Stripe Checkout page to make payment rather than custom checkout process
const directStripeCheckout = true

const linkStyle = {
  color: '#ffffff',
  cursor: 'pointer'
}

const buttonLinkStyle = {
  color: '#fff',
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  fontSize: '16px',
  padding: 0,
  textDecoration: 'underline'
}

// https://stripe.com/docs/elements/appearance-api?platform=web#others
// check here all styles attribute
const appearance = {
  theme: 'none',
  variables: {
    colorTextSecondary: '#FFFFFF',
    // colorTextPlaceholder: '#FFFFFFB3',
    // colorBackground: '#FFFFFF00',
    colorText: '#FFFFFF',
    colorDanger: '#FFFFFF',
    fontFamily: 'Playfair Display',
    borderRadius: '8px',
  },
  rules: {
    '*': {
      fontFamily: 'Playfair Display',
    },
    '.Label': {
      marginBottom: '6px',
    },
    '.Tab, .Input, .Block': {
      boxShadow: '0px 3px 10px #122A4214',
      padding: '12px'
    },
    '.Input': {
      backgroundColor: '#FFFFFF00',
      border: '1px solid #FFFFFFB3'
    },
    '.Input::placeholder': {
      color: '#FFFFFFB3',
      /* Firefox */
    },
    '.Input:-ms-input-placeholder': {
      /* Internet Explorer 10-11 */
      color: '#FFFFFFB3'
    },
    '.Input::-ms-input-placeholder': {
      /* Microsoft Edge */
      color: '#FFFFFFB3'
    },
    '.Input:focus-visible': {
      outline: 'none',
    },
    '.Error': {
      borderRadius: '7px',
      boxShadow: 'none',
      color: '#FFFFFF',
      backgroundColor: '#FF0302',
      borderWidth: '0',
      padding: '5px 10px',
      margin: '5px 0',
    }
  }
}


const SubscribePage = (props) => {
  const { t, i18n } = useTranslation()
  const baseUrl = i18n.language === 'sv' ? '' : '/' + i18n.language;
  const navigate = useNavigate()
  // logout
  // props.firebase.auth.signOut()

  const [products, setProducts] = useState([])
  const [userInfo, setUserInfo] = useState({
    email: '',
    password: '',
    uid: ''
  })
  const [paymentObj, setPaymentObj] = useState({
    email: '',
    priceId: '',
    coupon: null,
    amount: -1,
    discountAmount: 0,
    total: -1,
    tax: 0
  })
  const [error, setError] = useState(null)

  const [promoCode, setPromoCode] = useState('')
  const [promoObj, setPromoObj] = useState({})
  const [promoError, setPromoError] = useState('')

  const [isLoggedIn, setIsLoggedIn] = useState(false) // user is currently login ?
  const [isLoginProcess, setIsLoginProcess] = useState(false) // user is going to login or signup ?
  const [clientSecret, setClientSecret] = useState(null) // here clientSecret key means stripe payment secret key token to initiate payment

  const [isLoading, setIsLoading] = useState(false)
  let [isApplyingPromo, setIsApplyingPromo] = useState(false)
  let [isFuturePayment, setIsFuturePayment] = useState(false)
  let [isDiscountCalculated, setIsDiscountCalculated] = useState(false)

  useEffect(() => {
    let isMounted = true

    if (props.firebase.auth.currentUser && isMounted) {
      userInfo.uid = props.firebase.auth.currentUser.uid
      userInfo.email = props.firebase.auth.currentUser.email

      setIsLoggedIn(true)
    }

    return () => {
      isMounted = false
    }
  }, [props.firebase.auth.currentUser, userInfo])

  /**
   * if user already have a subscription plan then redirect to account manage page
   */
  useEffect(() => {
    if (props.firebase.userSubscription) {
      navigate(ROUTES.PAYMENT)
    }

  }, [props.firebase.userSubscription])

  // fetch all available plans
  /**
   *
   */
  useEffect(() => {
    const fetchProducts = async () => {
      if (products.length > 0) return;

      let products_arr = await props.firebase.getProducts();
      products_arr = products_arr.filter(([productId]) => {
        // show only yealy plan
        return productId == 'prod_KkI0cN2pY3y90i'
      })

      setProducts(products_arr);

      if (products_arr.length > 0) {
        const setIntt = setInterval(() => {
          const pro = products_arr[0][1];
          if (pro.prices) {
            clearInterval(setIntt);
            // const amount = parseFloat(pro.prices.data.unit_amount / 100).toFixed(2);
            const amount = parseFloat(202).toFixed(2);
            const tax = parseFloat(amount * 25 / 100).toFixed(2);

            setPaymentObj({
              ...paymentObj,
              product: pro,
              priceId: pro.prices.id,
              amount: amount,
              total: amount,
              tax: tax
            });
          }
        }, 50);
      }
    }

    fetchProducts();

  }, [props.firebase.productsFlag])

  useEffect(() => {
    let isMounted = true;

    let ss = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );
    if (ss) {
      setClientSecret(ss);
    }

    ss = new URLSearchParams(window.location.search).get(
      "setup_intent_client_secret"
    )
    if (ss && isMounted) {
      setClientSecret(ss);
      setIsFuturePayment(true);
    }

    return () => {
      isMounted = false;
    }
  }, [])

  const verifyLoadCheckout = async ({ promoObj = null, priceId = null }) => {
    if (!priceId && !paymentObj.priceId) {
      catchError({ message: 'Please select a plan' });
      return;
    }
    if (!priceId && paymentObj.priceId) priceId = paymentObj.priceId;

    setIsLoading(true)

    if (directStripeCheckout) {
      const docRef = await props.firebase.firedb
        .collection('customers')
        .doc(userInfo.uid)
        .collection('checkout_sessions')
        .add({
          price: priceId,
          tax_rates: taxRates,
          allow_promotion_codes: true,
          promotion_code: 'promo_1OAUs8Fha9hdCHBgZRlIyHp7', // apply promocode 'prod_KkHzBCY5YgLGP4' by default
          success_url: window.location.origin + '/thankyou',
          cancel_url: window.location.origin + '/subscribe/offer2',
          mode: 'subscription',
          trial_from_plan: false
        })

      docRef.onSnapshot(async snapshot => {
        const { error, sessionId } = snapshot.data()

        if (error) {
          console.log('checkout_session_error', error)
          // alert(t('checkout_session_error', { error: error.message }))
          error.message = t('checkout_session_error', { error: error.message })

          setIsLoading(false)
          setError(error)
        }

        if (sessionId) {
          // redirect to stripe checkout page
          const stripe = await loadStripe(process.env.REACT_APP_STRIPE_API_KEY)
          stripe.redirectToCheckout({ sessionId })
        }
      })
      return;
    }

    const headers = new Headers()
    headers.append('Content-Type', 'application/json')

    return await fetch(process.env.REACT_APP_FIREBASE_FUNCTION_URL + "stripeApi/createCheckoutSession", {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        price: priceId,
        success_url: window.location.origin + '/thankyou',
        cancel_url: window.location.origin + '/subscribe/offer2',
        promotion_code: promoObj?.id ?? null,
        allow_promotion_codes: promoObj.id ? false : true,
        customer_email: userInfo.email
      }),
    })
      .then((res) => {
        if (priceId) setIsLoading(false)

        setIsApplyingPromo(false)
        if (res.ok === false) {
          return Promise.reject(res)
        }
        return res.json()
      })
      .then(async (res) => {
        // res.id = checkout session id
        // res.url = checkout session url, where user can pay directly
        // res.amount_total = checkout session amount which one needs to pay via user
        // console.log('session obj', res)

        if (res.id) {
          if (promoObj.id) {
            setPromoObj(promoObj)
            setIsDiscountCalculated(false) // set to false to re-calculate discount
          }
          return true
        }
        return false
      })
      .catch(error => {
        if (error.message) {
          catchError(error)
        } else {
          error.json().then((error) => {
            if (error.message === 'This coupon cannot be redeemed because it does not apply to anything in this order.') {
              error.code = 'stripe_cannot_reedemed'

              setPromoObj({})
              setPromoCode('')
              setIsDiscountCalculated(false) // set to false to re-calculate discount
            }
            catchError(error)
          })
        }
        return false
      })

  }

  async function createPayment() {
    if (!userInfo.uid) return

    if (props.firebase.userSubscription) {
      console.log('firebase.userSubscription', props.firebase.userSubscription)
      navigate(ROUTES.PAYMENT)
      return
    }

    if (directStripeCheckout) {
      verifyLoadCheckout({ promoObj: {}, priceId: null })
      return
    }

    if (promoObj.id) {
      const res = await verifyLoadCheckout({ promoObj })
      if (!res) return
    }

    const headers = new Headers()
    headers.append('Content-Type', 'application/json')
    // headers.append('Accept', 'application/json')

    console.log('paymentObj', paymentObj)

    setIsLoading(true) // show loader

    // Create PaymentIntent as soon as the page loads
    await fetch(process.env.REACT_APP_FIREBASE_FUNCTION_URL + "stripeApi/stripePaymentIntent", {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        email: userInfo.email,
        priceId: paymentObj.priceId ?? null,
        coupon: paymentObj.coupon ?? null,
        promotion_code: paymentObj.promotion_code ?? null,
        taxRates
      }),
    })
      .then((res) => {
        setIsLoading(false) // hide loader

        if (res.ok === false) {
          return Promise.reject(res)
        }
        return res.json()
      })
      .then(async (data) => {
        console.log('data', data)
        setClientSecret(data.clientSecret)

        if (data.futurePayment) {
          setIsFuturePayment(data.futurePayment)
        }
      })
      .catch(error => {
        if (error.message) {
          catchError(error)
        } else {
          error.json().then((error) => {
            if (error.code === 'resource_missing') error.code = 'stripe_resource_missing'
            catchError(error)
          })
        }
      })
  }

  const onChange = event => {
    const { name, value } = event.target
    setUserInfo(userInfo => ({ ...userInfo, [name]: value }))
  }

  const updateLoginProcess = (event) => {
    event.preventDefault()
    setIsLoginProcess(!isLoginProcess)
  }

  const catchError = error => {
    console.log('error', error)
    if (ErrorsObj.hasOwnProperty(error.code)) {
      error.message = ErrorsObj[error.code]
    }

    setError(error)
  }

  const submitUser = (event) => {
    event.preventDefault()
    setIsLoading(true) // show loader

    var { email, password } = userInfo

    if (isLoginProcess) {
      props.firebase
        .doSignInWithEmailAndPassword(email, password)
        .then(async (authUser) => {
          userInfo.uid = authUser.user.uid

          await createPayment()
        })
        .catch(error => {
          setIsLoading(false) // hide loader
          catchError(error)
        })

    } else {
      props.firebase
        .doCreateUserWithEmailAndPassword(email, password)
        .then(async (authUser) => {
          // Create a user in your Firebase realtime database
          // console.log('CREATED', authUser, props.route)
          userInfo.uid = authUser.user.uid

          await updateUserDataInDB(props, userInfo.uid, {
            uid: userInfo.uid,
            email: email
          })

          await createPayment()

          // setUserInfo(INITIAL_STATE)
          setError(null)
        })
        .catch(error => {
          setIsLoading(false) // hide loader
          catchError(error)
        })
    }
  }

  const facebookLogin = event => {
    setIsLoading(true) // show loader
    props.firebase
      .doSignInWithFacebook()
      .then(async (socialAuthUser) => {
        userInfo.uid = socialAuthUser.user.uid
        userInfo.email = socialAuthUser.user.email

        // Create a user in your Firebase Cloud Database too
        await updateUserDataInDB(props, userInfo.uid, {
          uid: userInfo.uid,
          displayname: socialAuthUser.user.displayName,
          email: socialAuthUser.user.email
        })

        await createPayment()

        setError(null)
      })
      .catch(error => {
        catchError(error)
        setIsLoading(false) // hide loader
      })

    event.preventDefault()
  }

  const googleLogin = event => {
    setIsLoading(true) // show loader
    props.firebase
      .doSignInWithGoogle()
      .then(async (socialAuthUser) => {
        // console.log('socialAuthUser', socialAuthUser)
        userInfo.uid = socialAuthUser.user.uid
        userInfo.email = socialAuthUser.user.email

        // Create a user in your Firebase Cloud Database too
        await updateUserDataInDB(props, userInfo.uid, {
          uid: userInfo.uid,
          displayname: socialAuthUser.user.displayName,
          email: socialAuthUser.user.email
        })

        await createPayment()

        setError(null)
      })
      .catch(error => {
        catchError(error)
        setIsLoading(false) // hide loader
      })

    event.preventDefault()
  }

  const updateProduct = async (event) => {
    let index = event.target.value

    const product = products[index][1]
    const amount = parseFloat(product.prices.data.unit_amount / 100).toFixed(2)
    const tax = parseFloat(amount * 25 / 100).toFixed(2)

    setPaymentObj({
      ...paymentObj,
      product: product,
      priceId: product.prices.id,
      amount: amount,
      total: amount,
      tax: tax,
    })

    setClientSecret(null)
    setIsFuturePayment(false)
    if (promoObj.id) {
      await verifyLoadCheckout({ promoObj, priceId: product.prices.id })
    }

  }

  const applyPromoCode = event => {
    event.preventDefault()

    verifyPromoCode()
  }

  const updatePromoCode = event => {
    setPromoCode(event.target.value)

    setPaymentObj(paymentObj => ({
      ...paymentObj,
      coupon: null,
      discountAmount: 0
    }))
  }

  const removePromoCode = () => {
    setPaymentObj(paymentObj => ({
      ...paymentObj,
      coupon: null,
      discountAmount: -1
    }))

    setPromoError(null)
  }

  useEffect(() => {
    function calculateDiscount() {
      if (!promoObj.id || paymentObj.amount < 0) {
        setPaymentObj(paymentObj => ({
          ...paymentObj,
          promotion_code: null,
          discountAmount: 0,
          total: paymentObj.amount,
          tax: paymentObj.amount * 25 * 0.01,
          discountAmountLbl: null
        }))

        return
      }

      let amount_off = null, percent_off = null, coupon = null, promotion_code = null
      if ("promotion_code" === promoObj.object) {
        promotion_code = promoObj.id // promotional code ID
        amount_off = promoObj.coupon.amount_off
        percent_off = promoObj.coupon.percent_off
      } else {
        // coupon object
        coupon = promoObj.id // coupon code ID
        amount_off = promoObj.amount_off
        percent_off = promoObj.percent_off
      }

      let discountAmount = -1
      let discountAmountLbl = promoCode
      if (amount_off !== null && amount_off > 0) {
        discountAmount = parseFloat(amount_off / 100).toFixed(2)
        discountAmountLbl += ' (' + discountAmount + 'kr off)'

      } else if (percent_off !== null & percent_off > 0) {
        discountAmount = paymentObj.amount * percent_off * 0.01
        discountAmountLbl += ' (' + percent_off + '% off)'
      }

      if (discountAmount > -1) {
        discountAmount = parseFloat(discountAmount).toFixed(2)

        setPaymentObj(paymentObj => ({
          ...paymentObj,
          coupon: coupon,
          promotion_code: promotion_code,
          discountAmount,
          total: paymentObj.amount - discountAmount,
          tax: (paymentObj.amount - discountAmount) * 25 * 0.01,
          discountAmountLbl
        }))
      }
    }

    calculateDiscount()
    setIsDiscountCalculated(true)

  }, [isDiscountCalculated])

  async function verifyPromoCode() {
    setIsApplyingPromo(true)
    setPromoError(null)

    const headers = new Headers()
    headers.append('Content-Type', 'application/json')
    // headers.append('Accept', 'application/json')

    // Create PaymentIntent as soon as the page loads
    await fetch(process.env.REACT_APP_FIREBASE_FUNCTION_URL + "stripeApi/verifyPromoCode", {
      method: "POST",
      headers: headers,
      body: JSON.stringify({ promoCode }),
    })
      .then((res) => {
        if (res.ok === false) {
          return Promise.reject(res)
        }
        return res.json()
      })
      .then(async (res) => {
        await verifyLoadCheckout({ promoObj: res.data })
      })
      .catch(error => {
        setIsApplyingPromo(false)

        if (error.message) {
          setPromoError(error.message)
        } else {
          error.json().then((error) => {
            setPromoError(error.message)
          })
        }
      })
  }

  return (
    <AuthUserContext.Consumer>
      {authUser =>
        // authUser ? (
        //   navigate(ROUTES.ACCOUNT)
        // ) : (
        <div className='landingPage'>
          <div className='centerContent'>
            <div style={{ width: '100%' }}>
              <BlancheLogoRed className="logo" />

              <LanguageSwitcher list={true} />

              <h1 style={{ textAlign: 'center', marginBottom: '25px' }}>
                {t('Prova nu. Avsluta när du vill.')}
              </h1>

              <h2 className='subHeading' style={{ textAlign: 'center', letterSpacing: 0 }}>
                {/* {t('BLANCHE KVARTAL är det bästa valet för de allra flesta. 189 kronor för 3 månader.')}
                <br /> */}
                {t('Tillfredsställ ditt sinne - när du vill, var du vill, hur du vill – även offline!')}
              </h2>

              <h2 className='subHeading' style={{ textAlign: 'center' }}>
                <a href='https://blanchestories.com/kopa-presentkort/' style={{ color: '#9E0045', fontFamily: '"Josefin Sans",sans-serif', letterSpacing: 0, }}>{t('Vill du köpa ett presentkort - klicka här!')}</a>
              </h2>
            </div>
          </div>

          <div className='centerContent'>
            <div className='sectionContent steps step1'>
              <p style={{ marginTop: 0 }}>{t('steps_count', { count: 1 })}</p>
              <h2 className='sectionTitle'>{t('Kampanj erbjudande')}</h2>

              <div className='planList' onChange={updateProduct}>
                {products
                  .map(([productId, productData], index) => {
                    return (
                      <label
                        key={productId}
                        className={`planWrap`}
                      >
                        <h3 className='productName'>{t('Prova BLANCHE')}</h3>

                        <p className='productDesc'>
                          <span>
                            {t('202 kr för 1 år')} <br></br>
                          </span>
                          <span>{t('Abonnemanget övergår automatiskt till 595 kr/år')}</span>
                        </p>

                        <input type='radio' name='selectedProduct' value={index} defaultChecked={index === 0} />

                        <svg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg' ><circle cx='5' cy='5' r='5' fill='white'></circle></svg>
                      </label>
                    );
                })}
              </div>

              <form className={`promoForm ${(directStripeCheckout || products.length === 0) && 'hide'}`} onSubmit={applyPromoCode}>
                <div className=''>
                  {/* promo code field */}
                  <input type='text' className='inputStyle' value={promoCode} placeholder={t('Kampanjkod')} onChange={updatePromoCode} required />

                  {/* Apply button */}
                  {(paymentObj.discountAmount === 0) && (
                    <button type='submit' className='buttonStyle'>
                      <span className='button-text'>
                        {isApplyingPromo ? <div className="spinner"></div> : t('coupon_apply_btn')}
                      </span>
                    </button>
                  )}

                  {/* remove applied promo code button */}
                  {(paymentObj.discountAmount > 0) && (
                    <button type='button' className='buttonStyle' onClick={removePromoCode}>{t('coupon_remove_btn')}</button>
                  )}
                </div>
                {/* discounted amount */}
                {(paymentObj.discountAmount > 0) && (
                  <p>{t('subtotal_price', { price: (paymentObj.total) })}</p>
                )}

                {promoError && <p className='errorMessage'>{t(promoError)}</p>}
              </form>

              {/* <p className={!directStripeCheckout ? 'hide' : ''} style={{fontWeight: '900', textDecoration: 'underline', textAlign: 'center', paddingBottom: '30px'}}>{t('promocode_info_text')}</p> */}

              <div className='subsPoints'>
                <h3>{t('Så tillfredställer vi ditt sinne')}:</h3>
                {i18n.language === 'sv' ? (<ul>
                  <li><UlListIcon /><span>550+ stories, nya släpp varje vecka.</span></li>
                  <li><UlListIcon /><span>Korta romantiska och erotiska noveller.</span></li>
                  <li><UlListIcon /><span>Drömska godnattstories & lekfulla guider.</span></li>
                  <li><UlListIcon /><span>Reklamfri upplevelse.</span></li>
                  <li><UlListIcon /><span>Ingen bindningstid.</span></li>
                </ul>) : (<ul>
                  <li><UlListIcon /><span>550+ stories, new releases every week.</span></li>
                  <li><UlListIcon /><span>Romantic and erotic short stories.</span></li>
                  <li><UlListIcon /><span>Dreamy bedtime stories & playful guides.</span></li>
                  <li><UlListIcon /><span>Ad-free experience.</span></li>
                  <li><UlListIcon /><span>Cancel at any time.</span></li>
                </ul>)}
              </div>
            </div>

            {!clientSecret && (
              <div className='sectionContent steps step2'>
                <p style={{ marginTop: 0 }}>{t('steps_count', { count: 2 })}</p>

                {isLoggedIn ? (
                  <div>
                    {/* <p className='text-center'>
                      {t('You are already logged in')}
                    </p> */}

                    <table style={{ width: '100%' }}>
                      <tbody>
                        {paymentObj.product?.prices?.data.interval && (
                          <tr>
                            <td>{t('Term')}</td>
                            <td align='right'>
                              {t(paymentObj.product?.prices?.data.interval)}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td>{t('subtotal')}</td>
                          <td align='right'>
                            {paymentObj.amount > 0 ? paymentObj.amount : 0}kr
                          </td>
                        </tr>
                        {paymentObj.discountAmount > 0 && (
                          <tr>
                            <td>{paymentObj.discountAmountLbl}</td>
                            <td align='right'>
                              -{paymentObj.discountAmount}kr
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td>{t('tax')} (25% {t('Inclusive')})</td>
                          <td align='right'>
                            {paymentObj.tax > 0 ? (
                              parseFloat(paymentObj.tax).toFixed(2) + 'kr'
                            ) : '0kr'}
                          </td>
                        </tr>
                        <tr>
                          <td>{t('total')}</td>
                          <td align='right'>
                            {paymentObj.total > 0 ? paymentObj.total : 0}kr
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <br />

                    <button type='click' className='buttonStyle' onClick={createPayment} style={{backgroundColor: '#ff10f0', fontWeight: 900}}>
                      <span className='button-text'>
                        {isLoading ? <div className="spinner"></div> : t('Continue')}
                      </span></button>

                    {error && (
                      <p className='errorMessage'>
                        {t(error.message)}
                      </p>
                    )}
                  </div>
                ) : (
                  <div>
                    <form method='POST' action="" onSubmit={submitUser}>
                      <h2 className='sectionTitle'>{isLoginProcess ? t('Välkommen tillbaka') : t('create_acc_heading')}</h2>

                      <input name='email' value={userInfo.email} onChange={onChange} type='email' placeholder={t('email_lbl')} className='inputStyle' required />

                      <input name='password' value={userInfo.password} onChange={onChange} type='password' placeholder={t('passw_lbl')} className='inputStyle' required />

                      {error && (
                        <p className='errorMessage'>
                          {error.message === 'email-already-in-use' ? (
                            <Trans i18nKey="email-already-in-use">
                              Mejladressen finns redan registrerad. Du kan <a href={baseUrl + '/'} style={linkStyle}>logga in</a> eller <a href={baseUrl + ROUTES.PASSWORD_FORGET + `${userInfo.email ? '?email=' + userInfo.email : ''}`} style={linkStyle}>återställa lösenordet</a>.
                            </Trans>
                          ) : (
                            <>{t(error.message)}</>
                          )}

                        </p>
                      )}

                      {error && (
                        <PasswordForgetLink email={userInfo.email} />
                      )}

                      <button type='submit' className='buttonStyle' style={{backgroundColor: '#ff10f0', fontWeight: 900}}>
                        <span className='button-text'>
                          {isLoading ? <div className="spinner"></div> : isLoginProcess ? t('login_btn') : t('create_acc_btn')}
                        </span>
                      </button>

                      {/* <button type='button' className='buttonStyle socialButton' onClick={facebookLogin}>
                        <FacebookIcon style={{ marginRight: '8px' }} />
                        {t(isLoginProcess ? 'login_with' : 'acc_create_with', { lw: 'Facebook' })}
                      </button> */}

                      <button type='button' className='buttonStyle socialButton' onClick={googleLogin}>
                        <GoogleIcon style={{ marginRight: '8px' }} />
                        {t(isLoginProcess ? 'login_with' : 'acc_create_with', { lw: 'Google' })}
                      </button>
                    </form>

                    {/* when user not logged, show signup form */}
                    {!isLoginProcess && (
                      <p style={{ fontSize: '16px', letterSpacing: ".2px", textAlign: 'center' }}>
                        {t('Har du redan ett konto?')}{' '}
                        {/* <button type="button" style={buttonLinkStyle} onClick={updateLoginProcess}>{t('login_btn')}</button> */}
                        <Link to={baseUrl + '/'} reloadDocument style={{ color: '#fff' }}>
                          {t('login_btn')}
                        </Link>
                      </p>
                    )}

                    {/* otherwise show signin form */}
                    {isLoginProcess && (
                      <p style={{ fontSize: '16px', letterSpacing: ".2px", textAlign: 'center' }}>
                        {t('Är du ny här?')}{' '}
                        <button type="button" style={buttonLinkStyle} onClick={updateLoginProcess}>{t('create_acc_btn')}</button>
                      </p>
                    )}

                    <p style={{ fontSize: '12px', wordBreak: 'break-word' }}>
                      <Trans i18nKey="terms_privacy_text">
                        Genom att fortsätta godkänner du våra <a href='https://blanchestories.com/terms-of-use/' style={linkStyle}>Användarvillkor</a> och vår <a href='https://blanchestories.com/privacy-policy/' style={linkStyle}>Sekretesspolicy</a>.
                      </Trans>
                    </p>
                  </div>
                )}
              </div>
            )}

            {clientSecret && (
              <div className='sectionContent steps step3'>
                <p style={{ marginTop: 0 }}>Steg 3</p>

                <Elements stripe={stripePromise} options={{
                  clientSecret,
                  appearance
                }}>
                  <CheckoutForm isFuturePayment={isFuturePayment} clientSecret={clientSecret} />
                </Elements>
              </div>
            )}
          </div>
        </div>
        // )
      }
    </AuthUserContext.Consumer>
  )
}

export default withFirebase(SubscribePage)